import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isNilOrEmpty } from 'ramda-extension';
import { useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { codelists } from 'constants/codelists';
import { getCheckedRaAnalysis } from 'features/views/roboAdvisory/selectors';
import { getCodelistByName } from 'utils';

import RATableRow from './RATableRow';

const CheckedAnalysisTable = () => {
	const raTypesCodelist = useSelector(getCodelistByName(codelists.raAnalysisTypes));
	const raStatesCodelist = useSelector(getCodelistByName(codelists.raAnalysisStates));
	const raProductGroupsCodelist = useSelector(getCodelistByName(codelists.raProductGroups));

	const checkedRaAnalysis = useSelector(getCheckedRaAnalysis);
	const hasRecords = !isNilOrEmpty(checkedRaAnalysis);

	return (
		<Table size="small">
			<TableHead>
				<TableRow>
					<TableCell>
						<div>{getLabelMessage('roboAdvisory:analysisType')}</div>
						<div>{getLabelMessage('roboAdvisory:analysisState')}</div>
					</TableCell>
					<TableCell>{getLabelMessage('roboAdvisory:client')}</TableCell>
					<TableCell>
						<div>{getLabelMessage('roboAdvisory:personIn')}</div>
						<div>{getLabelMessage('roboAdvisory:businessIn')}</div>
					</TableCell>
					<TableCell>{getLabelMessage('roboAdvisory:product')}</TableCell>
					<TableCell>
						<div>{getLabelMessage('roboAdvisory:municipality')}</div>
						<div>{getLabelMessage('roboAdvisory:zipCode')}</div>
					</TableCell>
					<TableCell>{getLabelMessage('roboAdvisory:dateCreated')}</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{hasRecords &&
					checkedRaAnalysis.map((record, i) => (
						<RATableRow
							key={i}
							record={record}
							raTypesCodelist={raTypesCodelist}
							raStatesCodelist={raStatesCodelist}
							raProductGroupsCodelist={raProductGroupsCodelist}
						/>
					))}
			</TableBody>
		</Table>
	);
};

export default CheckedAnalysisTable;
